/**
 * @module app.bdc.reports.bdcNAPCtrl
 *
 */
define(['angular', 'moment'], function(angular, moment) {


    function BDCNAPCtrl($scope, $window, $rootScope, pricesService, orderService, napService, offerService) {
        var self = {};
        self.orderForm = $rootScope.orderForm;
        self.user = $rootScope.user;

        if (!self.orderForm) {
            return $scope.goTo('/bdc/list');
        }

        self.order = $rootScope.order;
        pricesService.setOrderForm(self.orderForm);
        pricesService.setOrder(self.order);

        self.isRental = orderService.isRental(self.order.contract.contractType.code);
        self.contractMonths = orderService.getContractMonths(self.order);
        self.isOlderOffer = offerService.isOlderOffer(self.order);
        self.tills = [];
        self.isMixed = false;
        self.nbTills = orderService.getNbTills(self.order.tills);
        self.cashDrawersByTillType = {};

        self.columnWidth = self.order.contract.scenarioType.code === 'PERIPHERIQUE' ? 'w40' : 'w50';

        /**
         * Get the date of the day
         * @return {String}
         */
        self.getDate = function getDate() {
            if(self.order.isSigned){
                return moment(self.order.dateSignature).format('DD/MM/YYYY');
            }
            return moment().format('DD/MM/YYYY');
        };

        self.getRDS = () => {
            if(self.order.isSigned){
                let rds = userService.findPerson(self.order.RDSRef);
                return rds.user.firstname + ' ' + rds.user.lastname;
            }
            return self.user.firstname + ' ' + self.user.lastname;
        }

        /**
         * Get installation date if defined
         * @return {String}
         */
        self.getDateInstallation = function () {
            return self.order.dateInstallation
                ? moment(self.order.dateInstallation, 'YYYY-MM-DD').format('MMMM YYYY')
                : null;
        };

        var _isAlreadyATill = false;

        /**
         * Get till pack description
         * @param {Object} order
         * @param {Boolean} isMixed
         * @param {Boolean} _isAlreadyATill
         * @return {String}
         */
        function _getDescription(isMixed, tillType) {
            return napService.getTillPackDescription(self.order, isMixed, _isAlreadyATill, tillType);
        }

        self.tillsConfig = self.order.tills.map(function(till) {
            return till.nbTills + ' ' + till.tillType.label + ' ' + till.label;
        });

        self.software = self.order.options.filter(function(option) {
            return option.optionType.code === 'LOGICIEL_CAISSE';
        });

        self.displayTotalPrice = function () {
            const promotionsTotalAmount = pricesService.calculatePromotionsTotalAmount(self.order.prices.promotions);
            const type = self.isRental ? 'rental' : 'purchase';
            return (
                (self.isRental ? self.order.prices.NAP.till.rental : self.order.prices.NAP.till.purchase) +
                self.order.prices.tillSoftware +
                self.order.prices.reintegration -
                promotionsTotalAmount +
                self.order.prices.NAP.scanup[type] +
                self.order.prices.NAP.scanupOptions[type] +
                self.order.prices.NAP.tabletAndPC[type] +
                self.order.prices.NAP.printer[type] +
                self.order.prices.NAP.tillAccessories[type] +
                self.order.prices.NAP.cashDrawers[type]+
                self.order.prices.prestationInstallation
            );
        };

        self.leaserSubtotal = () => {
            const promotionsTotalAmount = pricesService.calculatePromotionsTotalAmount(self.order.prices.promotions);
            return self.isRental ? (
                self.order.prices.NAP.till.rental +
                self.order.prices.tillSoftware +
                self.order.prices.reintegration -
                promotionsTotalAmount +
                self.order.prices.NAP.scanup['rental'] +
                self.order.prices.NAP.scanupOptions['rental'] +
                self.order.prices.NAP.tabletAndPC['rental'] +
                self.order.prices.NAP.printer['rental'] +
                self.order.prices.NAP.tillAccessories['rental'] +
                self.order.prices.NAP.cashDrawers['rental']+
                self.order.prices.prestationInstallation
            ) : 0;
        }

        self.napSubtotal = () => {
            const promotionsTotalAmount = pricesService.calculatePromotionsTotalAmount(self.order.prices.promotions);
            return self.isRental ? 0 : (
                self.order.prices.NAP.till.purchase +
                self.order.prices.tillSoftware +
                self.order.prices.reintegration -
                promotionsTotalAmount +
                self.order.prices.NAP.scanup['purchase'] +
                self.order.prices.NAP.scanupOptions['purchase'] +
                self.order.prices.NAP.tabletAndPC['purchase'] +
                self.order.prices.NAP.printer['purchase'] +
                self.order.prices.NAP.tillAccessories['purchase'] +
                self.order.prices.NAP.cashDrawers['purchase']+
                self.order.prices.prestationInstallation
            );
        }

        // Collection filters for ng-repeat options
        self.optionsFilter = function (option) {
            return (
                !(
                    option.optionType.code === 'NAP' ||
                    option.optionType.code === 'TPE' ||
                    option.optionType.code === 'LOGICIEL'
                ) && option.optionType.code !== 'LOGICIEL_CAISSE'
                && option.optionType.code !== 'PRESTATION'
                && option.optionType.code !== 'GESTION'
            );
        };

        self.softwareFilter = function (option) {
            return option.optionType.code === 'LOGICIEL_CAISSE';
        };

        self.prestationFilter = (option) => {
            return option.optionType.code === 'PRESTATION';
        }

        self.prestationPriceFilter = (price) => {
            return price.nbTills === self.nbTills && price.type.code === self.order.contract.contractType.code;
        }

        self.tpeDevicesFilter = function (option) {
            return option.isTPEDevice && option.optionType.code === 'TPE';
        };

        self.tpeOptionsFilter = function (option) {
            return (
                (!option.isTPEDevice && option.optionType.code === 'TPE') ||
                (self.isOlderOffer && option.isTPEDevice && !option.isDefault && option.optionType.code === 'TPE') ||
                option.optionType.code === 'LOGICIEL'
            );
        };

        self.hasTpeOptions = function() {
            let array = self.order.options.reduce((curr, option) => {
                if(self.tpeOptionsFilter(option)){
                    curr.push(option);
                }
                return curr;
            }, []);
            return array.length > 0;
        };

        self.hasTpeDevice = function() {
            let array = self.order.options.reduce((curr, option) => {
                if(self.tpeDevicesFilter(option)){
                    curr.push(option);
                }
                return curr;
            }, []);
            return array.length > 0;
        };

        self.cashDrawerPricesFilter = function (price) {
            if (
                price.type.code === self.order.contract.contractType.code &&
                price.marketType.code === self.order.marketType.code
            ) {
                return true;
            }
        };

        // Price type filter for each group of options
        self.getTpeDevicesPriceType = function getTpeDevicesPriceType(option) {
            return self.isRental ? self.order.contract.contractType.code : 'LOC48';
        };

        self.getTpeOptionsPriceType = function getTpeOptionsPriceType(option) {
            return napService.isTpeOptionException(option.reference) ? self.order.contract.contractType.code : 'ACHAT';
        };

        self.displayTpeMonths = function displayTpeMonths(type) {
            return type === 'LOC36' ? '48' : orderService.getContractMonths(self.order);
        };

        function _isTPEDevices() {
            self.isTPEDevices = false;

            for (var i = 0; i < self.order.options.length; i++) {
                if (
                    self.order.options[i].isTPEDevice &&
                    (self.order.options[i].nbOptions > 0 || self.order.options[i].nbOffered > 0)
                ) {
                    self.isTPEDevices = true;
                }
            }
        }

        function _getCashDrawersByTillType() {
            self.order.cashDrawers.forEach(function(cashDrawer) {
                if (cashDrawer.tillType.code) {
                    self.cashDrawersByTillType[cashDrawer.tillType.code] = cashDrawer;
                }
                else {
                    self.cashDrawersByTillType['default'] = cashDrawer;
                }
            });
        }

        _isTPEDevices();
        _getCashDrawersByTillType();

        /**
         * Init the tills list
         * If not mixed, a till = a line
         * If mixed, a line = a till familly
         */
        function _initTillsList() {
            var till = null;
            var nbTills = self.order.contract.scenarioType.code === 'EXTENSION' ? self.order.contract.nbTillsAdded : 1;
            var mixedTillTypes = orderService.areTillsMixed(self.order.tills);
            var mixedTills = {
                'BH+': [],
                BF: []
            };

            self.isMixed = mixedTillTypes.isMixed;

            for (var i = 0; i < self.order.tills.length; i++) {
                till = self.order.tills[i];
                for (var j = 0; j < self.order.tills[i].nbTills; j++) {
                    if (mixedTillTypes.isMixed && self.isOlderOffer) {
                        mixedTills[till.tillType].push(till.tillType.label + ' ' + till.label);
                    }
                    else {
                        self.tills[till.tillType.code] = {
                            reference: till.reference,
                            label: till.label,
                            description: _getDescription(false, till.tillType.code),
                            nbTills: 1,
                            pricePurchase:
                                pricesService.getSimpleTillPrice(till.tillType.code, nbTills, 'ACHAT') -
                                pricesService.getSimpleTillPrice(till.tillType, nbTills - 1, 'ACHAT'),
                            priceRental:
                                pricesService.getSimpleTillPrice(till.tillType.code, nbTills, 'LOC48') -
                                pricesService.getSimpleTillPrice(till.tillType, nbTills - 1, 'LOC48'),
                            tillType: till.tillType
                        };
                        nbTills++;
                    }
                }
            }

            if (mixedTillTypes.isMixed && self.isOlderOffer) {
                var nbTillsOrderModel = orderService.getNbTillsByTillType(self.order.tills);
                var pricesRental = pricesService.getMixedTillPrice(nbTillsOrderModel, 'LOC48');
                var pricesPurchase = pricesService.getMixedTillPrice(nbTillsOrderModel, 'ACHAT');

                self.tills.push({
                    reference: 'PACKNSBICBH',
                    label: mixedTills['BH+'].join(', '),
                    description: _getDescription(true),
                    nbTills: nbTillsOrderModel['BH+'],
                    pricePurchase: pricesPurchase['BH+'],
                    priceRental: pricesRental['BH+']
                });

                self.tills.push({
                    reference: 'PACKNSBICBH',
                    label: mixedTills['BF'].join(', '),
                    description: _getDescription(true),
                    nbTills: nbTillsOrderModel['BF'],
                    pricePurchase: pricesPurchase['BF'],
                    priceRental: pricesRental['BF']
                });
            }

            self.hasPromotion = function hasPromotion() {
                return self.order.promotions.length > 0;
            };
        }

        _initTillsList();

        return self;
    }

    BDCNAPCtrl.$inject = [
        '$scope',
        '$window',
        '$rootScope',
        'pricesService',
        'orderService',
        'napService',
        'offerService'
    ];

    angular.module('app.bdc.reports.bdcNAPCtrl', []).controller('BDCNAPCtrl', BDCNAPCtrl);
});
